<template>
  <div class="modal fade show" v-if="Object.keys(basic_modal_data).length">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header my-modal-header">
          <div class="row">
            <div class="col-10">
              <h5 class="mt-0 font-size-12 text-primary">{{ board_name }}</h5>
            </div>
            <div class="col-2">
              <button type="button" class="btn-close float-end" @click="closeModalCard()"></button>
              <card-options :bucketId="basic_modal_data.bucket_id" :itemId="basic_modal_data.id" :index="0"
                :userAdmin="userAdmin" @deleteTask="deleteTask" @copyTask="copyTask" @openLogTask="openLogTask" />
            </div>
            <div class="col-12">
              <card-name :named="basic_modal_data.name" id="name" @input="updateLocalData" :userAdmin="userAdmin" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-4">
              <app-usuarios :users="board_users[0]" :preSelectedUsers="basic_modal_data.users" :userAdmin="userAdmin"
                @userAdded="userAdded" @userRemoved="userRemoved" />
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <app-input-select :options="buckets_list" :disabled="false" :value="basic_modal_data.bucket_id"
                label="Bucket" :notDefault="true" id="bucket_id" @input="updateLocalData" />
            </div>
            <div class="col-4">
              <app-input-select :options="status_list" :disabled="false" v-model="basic_modal_data.status"
                label="Status da tarefa" id="status" :notDefault="true" @input="updateLocalData" />
            </div>
            <div class="col-3">
              <app-input-date :value="basic_modal_data.date_end" id="date_end" label="Data da tarefa"
                @input="updateLocalData" :userAdmin="userAdmin" />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-textarea label="Descrição da tarefa" id="description" :value="basic_modal_data.description"
                @input="updateLocalData" :userAdmin="userAdmin" />
            </div>
          </div>
        </div>
        <div class="modal-body my-modal-body">
          <div class="row">
            <div class="col-12">
              <hr />
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-10">
              <h5 class="mt-0 font-size-14 text-primary">Detalhes:</h5>
            </div>
            <div class="col-2 text-right" style="text-align:right">
              <i class="mdi mdi-chevron-up font-size-22 text-reset" v-if="viewOutherProperties"
                @click="viewOutherProperties = !viewOutherProperties"></i>
              <i class="mdi mdi-chevron-down font-size-22 text-reset" v-else
                @click="viewOutherProperties = !viewOutherProperties"></i>
            </div>
            <div class="row mt-0" v-if="viewOutherProperties">
              <!-- propriedades sobre medidas -->
              <template v-if="Object.keys(inputs_values_list).length > 0">
                <app-dinamic-form v-for="(p, pIndex) in inputs_values_list" :index="pIndex" :key="`dinamic-$${p.propertie_id}`"
                  :propertie="p" :value="p.value_value" :id="p.propertie_id" :task="active_id" :userAdmin="userAdmin"
                  :menbers="board_users[0]" @updateCustomPropertie="updateCustomPropertieValue"
                  @updatePropertiesInSelected="updatePropertiesInSelected" />
              </template>
              <!-- formatos / quantidades / totais -->
              <task-formats :task_id="active_id" :userAdmin="userAdmin" />
              <!-- links-->
              <div class="col-12 mt-0">
                <hr />
              </div>
              <div class="col-12 mt-1 mb-3">
                <h5 class="mt-0 font-size-14 text-primary">Links:</h5>
              </div>
              <div class="col-12">
                <app-input-url label="URL Iu Flow" :icon="true" id="url_iu_flow" :value="basic_modal_data.url_iu_flow"
                  @input="updateLocalData" />
              </div>
              <div class="col-12">
                <app-input-url label="URL Share Point" :icon="true" id="url_sharepoint"
                  :value="basic_modal_data.url_sharepoint" @input="updateLocalData" />
              </div>
              <div class="col-12">
                <app-input-url label="URL Bynder" :icon="true" id="url_bynder" :value="basic_modal_data.url_bynder"
                  @input="updateLocalData" />
              </div>
              <div class="col-12">
                <app-input-url label="URL Figma" :icon="true" id="url_figma" :value="basic_modal_data.url_figma"
                  @input="updateLocalData" />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr />
              </div>
            </div>
            <div class="row align-items-center mt-0">
              <div class="col-12 mt-1 mb-2">
                <h5 class="mt-0 font-size-14 text-primary">Comentários:</h5>
              </div>
            </div>
            <modalComment :id="active_id" :users="board_users[0]" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { status } from '../../../data/data-static.js'
import { mapActions } from "vuex";
import AppUsuarios from "./usuarios.vue";
import CardName from "./CardName.vue";
import modalComment from "./Comment.vue";
import AppInputSelect from "@/components/AppInputSelect/AppInputSelect.vue";
import AppTextarea from "@/components/AppTextarea/AppTextarea.vue";
import AppDinamicForm from "./AppDinamicForm.vue";
import AppInputUrl from "@/components/AppInputText/AppInputUrl.vue";
import AppInputDate from "@/components/AppInputDate/AppInputDate.vue";
import CardOptions from "./CardOptions.vue";
import TaskFormats from './TaskFormats.vue'
export default {
  props: {
    active_id: {
      type: Number,
      default: null
    },
    board_id: {
      type: Number,
      default: null
    },
    board_name: {
      type: String,
      default: null
    },
    board_users: {
      type: [Object, Array],
      default: (() => { })
    },
    userAdmin: {
      type: Number,
      default: 0
    }
  },
  components: {
    CardOptions,
    CardName,
    AppUsuarios,
    AppInputSelect,
    AppInputDate,
    AppTextarea,
    AppInputUrl,
    TaskFormats,
    modalComment,
    AppDinamicForm,
  },
  mounted() {
    this.passiveLoad()
    //this.updateCombinedData();
    //this.ativarProtecao();
  },
  beforeDestroy() {
    //this.removerProtecao();
  },
  watch: {
    //formDinamic: "updateCombinedData"
  },
  data() {
    return {
      viewOutherProperties: true,
      basic_modal_data: {},
      buckets_list: {},
      status_list: {},
      inputs_values_list: {},
    };
  },
  created() {
    this.status_list = status;
    //this.formatCustomData();
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    //Lê os dados da tarefa
    async passiveLoad() {
      try {
        this.showLoader(true);
        const response = await this.$AppCallApi("GET", `f-task-modal/${this.active_id}/${this.board_id}`);
        if (response.status === 200) {
          const d = response.data.data;
          this.basic_modal_data = d.task;
          this.buckets_list = d.buckets;
          this.consolidaInputsValues(d.inputs, d.inputs_values);
          console.log('load', JSON.stringify(d))
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        this.showLoader(false);
      }
    },

    traslateInputValues(value, key){
      let key_text = null;
      let value_text = null;

      if(key === 'name') {
        key_text = 'Nome do card para ';
        value_text = value;
      }
      else if(key === 'bucket_id') {
        key_text = 'Moveu o card para ';
        const temp = this.buckets_list.find(b => b.id === parseInt(value))
        value_text = temp && temp.value ? temp.value : null;
      }
      else if(key === 'status') {
        key_text = 'Status do card para ';
        const temp = this.status_list.find(s => s.id === value)
        value_text = temp && temp.value ? temp.value : null;
      }
      else if(key === 'date_end') {
        key_text = 'Data da tarefa definida para ';
        value_text = value;
      }
      else if(key === 'description') {
        key_text = 'Descrição do card definida para ';
        value_text = value;
      }
      else if(key === 'url_iu_flow') {
        key_text = 'Url do Iu Flow para ';
        value_text = value;
      }
      else if(key === 'url_sharepoint') {
        key_text = 'Url do SharePoint para ';
        value_text = value;
      }
      else if(key === 'url_bynder') {
        key_text = 'Url da Bynder para ';
        value_text = value;
      }
      else if(key === 'url_figma') {
        key_text = 'Url do Figma para ';
        value_text = value;
      }
      

      return {
          key_text: key_text,
          value_text: value_text
        }
    },
    //atualiza variaveis na api
    async updateLocalData(value, id) {
      console.log('updateLocalData')
      const key_log = this.traslateInputValues(value, id);
      console.log('key_log', key_log);
      const data = { "key": id, "value": value, ...key_log };
      const response = await this.$AppCallApi("put", `f-task-single-value-path/${this.active_id}`, data);
      console.log('status: ', response)
      if (response.status === 200) {
        this.updateBasicModalData(id, value)
      }
      else {
        this.showMessage({
          title: "Desculpe um erro aconteceu!",
          css: "bg-danger"
        });
      }
    },
    async updateCustomPropertieValue(value, string_id) {
      console.log('updateCustomPropertieValue', value, string_id)
      if ((!string_id || string_id.match(/-/g) || []).length != 2) {
        this.showMessage({
          title: "Desculpe um erro aconteceu!",
          css: "bg-danger"
        });
        return;
      }
      const ids = string_id.split("-")
      let temp_value = null;
      //Campo do tipo select
      let propertie = this.inputs_values_list.find(p=> p.propertie_id === parseInt(ids[0]));
      const logText = {
        key_text: null,
        value_text: null
      }
      logText.key_text = `Alterou a propriedade ${propertie.name} para `;  
      if(ids[1] === "6"){
        temp_value = value && value.id ? value.id : null;
        const propertie_value = propertie ? JSON.parse(propertie.values) : null;
        if(propertie_value){
            let key_name = propertie_value.find(pv=> parseInt(pv.id) === parseInt(temp_value));
            logText.value_text = key_name && key_name.name ? key_name.name : null; 
        }
      }
      else if(ids[1] === "14"){
          let temp = [];
          value.forEach(el => {
            temp.push(el.name)
          });

          temp_value = value ? value : null
          logText.value_text = temp.join(", ");
      }
      else{
        temp_value = value ? value : null
        logText.value_text = temp_value;
      }
      

      const data = {
        propertie_id: ids[0],
        propertie_type: ids[1],
        task_id: ids[2],
        propertie_value_id: temp_value,
        ...logText
      }

      const response = await this.$AppCallApi("POST", `f-propertie`, data);
      if (response.status != 200) {
        this.showMessage({
          title: "Desculpe um erro aconteceu!",
          css: "bg-danger"
        });
      }

      console.log('data', data)

    },
    async updatePropertiesInSelected(id, value) {
      console.log('updatePropertiesInSelected', id, value)
    },
    //Consolida os valores do formulário dinâmico
    consolidaInputsValues(inputs, values) {
      if (!Array.isArray(inputs) || inputs.length === 0) {
        this.inputs_values_list = [];
        return;
      }
      const merged = inputs.map(inp => {
        const inp_pid = Number(inp.propertie_id);
        const value = values.find(v => Number(v.propertie_id) === inp_pid);
        return {
          ...inp,
          value_id: value ? value.id : null,
          value_value: value ? value.value : null
        };
      });
      this.inputs_values_list = merged;
    },
    //Atualiza as variáveis localmente
    updateBasicModalData(key, value) {
      if(key === 'bucket_id'){
        value = parseInt(value);
      }
      this.basic_modal_data[key] = value;
    },
    //Adiciona usuários na tarefa
    async userAdded(user) {
      if (!user || !user.id) { return false; }
      const data = { "user_id": user.id };
      const response = await this.$AppCallApi("post", `f-task-add-user/${this.active_id}`, data);
      if (response.status != 200) {
        this.showMessage({
          title: "Desculpe um erro aconteceu!",
          css: "bg-danger"
        });
      }
      //addUserInTask
    },
    //Remove usuários na tarefa
    async userRemoved(user) {
      if (!user || !user.id) { return false; }
      const data = { "user_id": user.id };
      const response = await this.$AppCallApi("post", `f-task-remove-user/${this.active_id}`, data);
      if (response.status != 200) {
        this.showMessage({
          title: "Desculpe um erro aconteceu!",
          css: "bg-danger"
        });
      }
    },
    closeModalCard() {
      console.log('fechar')
      this.$emit("closeModalCard");
    },
    deleteTask() {

    },
    copyTask() {

    },
    openLogTask(value){
      this.$emit("openLogTask", value);
    }
  }
};
</script>
<style scoped>
.modal.show {
  display: block;
  background: rgba(0, 102, 255, 0.5);
}

.modal-content {
  box-shadow: 0 0.75rem 1.5rem rgba(255, 255, 255, 0.3);
  background: #fff;
  border-radius: 0px !important;
}

.my-modal-header {
  display: block;
}

.my-modal-header,
.modal-body {
  padding: 2rem;
  border: none !important;
}

.my-modal-header {
  padding-bottom: 0rem;
}

.modal-body {
  padding-top: 0rem;
}

.my-modal-header h5 {
  display: block;
}

.btn-close {
  margin-top: -5px;
}

.btn-fixed-right {
  position: fixed;
  float: left;
  right: -200px;
  width: 150px;

}
</style>